import React, { Component, Fragment } from 'react';
import Utils from './../../../../../../../utils';
import SectionBlock from './../../../../SectionBlock/SectionBlock';
import SmallScoreBarSection from './../../../../SmallScoreBarSection/SmallScoreBarSection';
import ScoreRange from './../../../../../constants/ScoreRange';
import ScoreDisplayTypes from './../../../../../constants/ScoreDisplayTypes';
import ReportHelper from './../../../../../helpers/ReportHelper';
import ScoreBarTypes from '../../../../../constants/ScoreBarTypes';
import ScoreBarNG from './../../../../ScoreBarNG/ScoreBarNG';

// eslint-disable-next-line css-modules/no-unused-class
import style from './style/intellectualcapabilities.scss';

export default class IntellectualCapabilitiesAttachment extends Component {
    constructor(props) {
        super(props);

        this.getScoreBlockContent = this.getScoreBlockContent.bind(this);
    }

    /*
        todo: Comment for future changes: It's quite inefficient to call the getScoreBlockContent
         this many times in this component. It will loop through the array at every call. We
         should map this to an object using the names as the key, to directly query for it or if
         the code is almost identical, build all components in a loop, in a separate method.
     */
    getScoreBlockContent(name) {
        let getScoreBlockContent = null;

        this.props.content.scores.some(scoreBlock => {
            if (scoreBlock.name === name) {
                getScoreBlockContent = scoreBlock;
            }

            return getScoreBlockContent;
        });

        return getScoreBlockContent ? getScoreBlockContent : {};
    }

    getTextAndTypeForIcon(content, i18nParticipation) {
        let textForIcon = '';
        let typeForIcon = '';

        if (content.scoreByConsultant) {
            typeForIcon = 'user-edit';

            textForIcon = <p>{ i18nParticipation.report_by } { content.consultant ? content.consultant : i18nParticipation.report_consultant.toLowerCase() }</p>;
        } else if (content.score) {
            typeForIcon = 'desktop';

            if (content.scores.length > 1) {
                textForIcon = <p>{ content.basedOn }</p>;
            } else if (content.scores.length === 1) {
                textForIcon = <p>{ content.scores[0].basedOn }</p>;
            }
        }

        return { textForIcon, typeForIcon };
    }

    getAsideText(content, i18nParticipation) {
        let asideText = '';

        if (content.scores.length > 1) {
            asideText = i18nParticipation.report_score_bar_separate_aside;
        } else if (content.scores.length === 1) {
            asideText = content.scores[0].definition;
        }

        return asideText;
    }

    getScoreSection(identifier, title) {
        return <li>
            <SmallScoreBarSection
                title={title}
                scoreMin={ScoreRange.INTELLECTUAL_CAPABILITY.MIN}
                scoreMax={ScoreRange.INTELLECTUAL_CAPABILITY.MAX}
                scoreValue={this.getScoreBlockContent(identifier).score}
                iconText={<p
                    dangerouslySetInnerHTML={{ __html: this.getScoreBlockContent(identifier).basedOn }}/>}
                scoreLevelDescription={this.getScoreBlockContent(identifier).evaluation}
                classes={{
                    root: style.groupedScoreBlockSection__smallScoreBarSection,
                    fill: style.fill,
                    blank: style.blank,
                    roundIcon: {
                        roundIconFigureWrapper: style.intellectualCapabilities__roundIconFigureWrapper
                    }
                }}
                displayScore={
                    this.getScoreBlockContent(identifier).scoreTypes
                        ? ReportHelper.getScoreType(this.getScoreBlockContent(identifier).scoreTypes,
                            ScoreDisplayTypes.NORM5, 1)
                        : null
                }
                scoreBarType={!this.getScoreBlockContent(identifier).scoreByConsultant ? ScoreBarTypes.BAR_GRAPH : null}
            >
                <p className={style.intellectualCapabilities__smallScoreBarSectionDescription}>
                    {this.getScoreBlockContent(identifier).definition}
                </p>
            </SmallScoreBarSection>
        </li>;
    }

    render() {
        const {
            content,
            i18nParticipation
        } = this.props;

        // extract overall ability scores array if it exists, to see if a norm5 score was provided
        let norm5Score = null;

        if (!content.scoreByConsultant && content.scores) {

            // there no longer is a score object with overallAbility present in the scores array. instead, these
            // properties should be extracted from the root score object:
            if (content.scoreTypes) {
                norm5Score = ReportHelper.getScoreType(content.scoreTypes, ScoreDisplayTypes.NORM5, 1);
            }
        }

        let cutOffScore = null;

        if (content.cutOff) {
            cutOffScore = Number(content.scoreByConsultant || norm5Score || content.score);
        }

        return <Fragment>
            <div className={`${style.report_page_container} ${style.intellectualCapabilities}`}>

                {content.definition
                    ? <SectionBlock classes={{ root: style.sectionBlockBlue }}>
                        <p dangerouslySetInnerHTML={{ __html: content.definition }}/>
                    </SectionBlock>
                    : null
                }

                {content.cutOff
                    ? <SectionBlock>
                        { /* this is based on the main report section for intellectual capability extended as used for */}
                        { /* the pre-fit product. please note , there is no detail page for that product / report! */}
                        <section
                            className={style.intellectualCapabilityEvaluation__cutOff}
                            dangerouslySetInnerHTML={{ __html: content.evaluation }}
                        />

                        <section className={style.mainScoreBlockSection__cutOff}>

                            <section>

                                <header className={style.intellectualCapabilityScoresHeader__cutOff}>
                                    <div className={style.intellectualCapabilityMainScaleIcon__cutOff}>
                                        <figure/>
                                    </div>
                                    <section>
                                        <h3>{i18nParticipation[`report_${Utils.camelCaseToSnakeCase(content.handle)}`] || content.handle}</h3>
                                        <span>{ content.basedOn }</span>
                                    </section>
                                </header>

                                <p className={ style.mainScoreBlockSectionDefinition__cutOff }>{ content.definition }</p>

                                <ScoreBarNG
                                    scoreMin={ ScoreRange.INTELLECTUAL_CAPABILITY_EXTENDED.MIN }
                                    scoreMax={ ScoreRange.INTELLECTUAL_CAPABILITY_EXTENDED.MAX }
                                    scoreValue={ cutOffScore }
                                    fill={ false }
                                    scoreBarType={ ScoreBarTypes.CUTOFF }
                                    disabled={ true }
                                    classes={{
                                        root: style.mainScoreBlockSection__cutOff,
                                        scoreBar: style.mainScoreBlockSection__cutOff__scoreBar
                                    }}
                                    digits={ 2 }
                                    valueLabelDisplay={ 'on' }
                                    cutOff={ content.cutOff  }
                                />
                                <p>
                                    { cutOffScore < content.cutOff
                                        ? i18nParticipation.report_intellectual_capability_extended_has_not_requested_level
                                        : i18nParticipation.report_intellectual_capability_extended_has_requested_level
                                    }
                                </p>

                            </section>
                        </section>
                    </SectionBlock>
                    : <SectionBlock>
                        <section className={ style.mainScoreBlockSection }>
                            <ul>
                                <li>
                                    <SmallScoreBarSection
                                        title={ i18nParticipation.report_general_ability }
                                        scoreMin={ ScoreRange.INTELLECTUAL_CAPABILITY.MIN }
                                        scoreMax={ ScoreRange.INTELLECTUAL_CAPABILITY.MAX }

                                        /* the score value (used to fill in score bar sections) is set to the section score, with an override for consultant score */
                                        scoreValue={ content.scoreByConsultant || content.score }

                                        /* the actual displayed score is either consultant-, norm5- or section score (in that order) */
                                        displayScore={ content.scoreByConsultant || norm5Score || content.score }

                                        iconText={ this.getTextAndTypeForIcon(content, i18nParticipation).textForIcon }
                                        iconType={ this.getTextAndTypeForIcon(content, i18nParticipation).typeForIcon }
                                        classes={{
                                            root: style.mainScoreBlockSection__smallScoreBarSection,
                                            fill: style.fill,
                                            blank: style.blank,
                                            roundIcon: {
                                                roundIconFigureWrapper: style.intellectualCapabilities__roundIconFigureWrapper
                                            },

                                            /* todo: check
                                            scoreRoundIcon: style.mainScoreBlockSection__scoreRoundIcon,
                                            roundIconFigureWrapper: style.intellectualCapabilities__roundIconFigureWrapper,
                                            */
                                        }}

                                        scoreLevelDescription={ content.scoreByConsultant &&
                                        content.evaluationByConsultant ? content.evaluationByConsultant
                                            : content.evaluation }
                                        scoreBarType={ !content.scoreByConsultant ? ScoreBarTypes.BAR_GRAPH : ScoreBarTypes.NORMAL }
                                        autoScaleWidth={ true }
                                    />
                                </li>
                                <li>
                                    <aside>
                                        <p>{ this.getAsideText(content, i18nParticipation) }</p>
                                    </aside>
                                </li>
                            </ul>
                        </section>
                    </SectionBlock>
                }

                { content.scores.length > 0 &&
                    <SectionBlock>
                        <section className={ style.groupedScoreBlockSection }>
                            <header className={ style.groupedScoreBlockSection__header }>
                                { i18nParticipation.report_score_bar_group_header }
                            </header>
                            <ul>
                                { Object.keys(this.getScoreBlockContent('abstractAbility')).length > 0 &&
                                    this.getScoreSection('abstractAbility', i18nParticipation.report_abstract_ability)
                                }
                                { Object.keys(this.getScoreBlockContent('numericalAbility')).length > 0 &&
                                    this.getScoreSection('numericalAbility', i18nParticipation.report_numerical_ability)
                                }
                                { Object.keys(this.getScoreBlockContent('verbalAbility')).length > 0 &&
                                    this.getScoreSection('verbalAbility', i18nParticipation.report_verbal_ability)
                                }
                                { Object.keys(this.getScoreBlockContent('gMatAbility')).length > 0 &&
                                    this.getScoreSection('gMatAbility', i18nParticipation.report_g_mat_ability)
                                }
                            </ul>
                        </section>
                    </SectionBlock>
                }
            </div>
        </Fragment>;
    }
}
